// The Fortress mark: a switchback trail climbing a terracotta hexagon to the
// summit flag. One source for the hub header and the sign-in screens; the
// same artwork as public/favicon.svg (heavier strokes for 16px) and
// assets/logo.svg (the app icon / splash source). Decorative — the visible
// "Fortress" wordmark beside it carries the name — so it is aria-hidden.
// Sized by CSS through `className`.

export function FortressMark({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 200 200"
      aria-hidden="true"
      focusable="false"
    >
      <polygon
        points="100,4 183.14,52 183.14,148 100,196 16.86,148 16.86,52"
        fill="#b4533a"
      />
      <polyline
        points="62,156 62,122 138,78.1 100,56.2"
        fill="none"
        stroke="#faf6ea"
        strokeWidth={20}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="100"
        y1="58"
        x2="100"
        y2="24"
        stroke="#faf6ea"
        strokeWidth={10}
        strokeLinecap="round"
      />
      <polygon points="100,20 134,32 100,44" fill="#faf6ea" />
    </svg>
  );
}
